import gsap from 'gsap'
import Lenis from 'lenis'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import 'lenis/dist/lenis.css'

gsap.registerPlugin(ScrollTrigger)

export let lenis

export const initLenis = () => {

  lenis = new Lenis({
		anchors: {
			offset: -100,
			duration: 1.8
		}
  })

	lenis.on('scroll', ScrollTrigger.update)

	gsap.ticker.add((time) => {
		lenis.raf(time * 1000)
	})

	gsap.ticker.lagSmoothing(0)

	const setScrollState = ({ scroll, direction }) => {
		document.documentElement.dataset.scrolled = scroll > 50
		document.documentElement.dataset.direction = direction === 1 && scroll > 0 ? 'forward' : 'backward'
	}

	lenis.on('scroll', setScrollState)

	setScrollState(lenis)

}

export const scrollToStart = () => {
  lenis.scrollTo(0, { immediate: true, force: true })
}

export const scrollToHash = (hash = window.location.hash.slice(1)) => {
  const target = hash && document.getElementById(decodeURIComponent(hash).replace(/^#/, ''))

  if (!target) return

  lenis.scrollTo(target, { offset: -100 })
}